import { Import } from 'lucide-react'
import ImportListings from '../pages/import-listings'

export default {
	icon: Import,
	name: 'Import Listings',
	component: ImportListings,
	heading: 'External Listings',
	featured: true,
	filter: ({ loggedIn }: any) => {
		return loggedIn
	}
}
